import { StatusCategoryKinds } from '../constants/workflows';

/**
 * "Awaiting the provider's response" is any INITIAL-kind status: REQUESTED, or
 * REOPENED after an opportunity re-broadcast. Never compare status codes for this —
 * the category kind is the contract, so a future initial-kind status is covered too.
 */
export function isAwaitingProviderResponse(
  status: { category_kind?: string | null } | null | undefined
): boolean {
  return status?.category_kind === StatusCategoryKinds.INITIAL;
}
